import { createSelector } from 'reselect';
import { CallbackSaga, createGeneralCall } from '@altermaind/core/requests-status-management';
import { IS_MOCK_ENABLED } from '@/_shared/constants/mock';
import { GenericApiError } from '@/_shared/types/apiError';
import { getCurrentOrganization } from '@/core/state/selectors';
import { API_GET_BILLING_LINK, KEY_GET_BILLING_LINK } from '../constants';
import { MOCK_RESPONSE_GET_BILLING_LINK } from '../mocks';
import { BillingLink } from '../types';

export type CallParamsGetBillingLink = {
  successSaga?: CallbackSaga;
  errorSaga?: CallbackSaga;
};

type CallResponseGetBillingLink = BillingLink;

type CallErrorGetBillingLink = GenericApiError;

type CallSelectorsGetBillingLink = {
  link: string;
};

export const getBillingLinkCall = createGeneralCall<
  CallParamsGetBillingLink,
  CallResponseGetBillingLink,
  CallErrorGetBillingLink,
  CallSelectorsGetBillingLink
>({
  id: KEY_GET_BILLING_LINK,
  url: () => state => {
    const org = getCurrentOrganization(state);
    return API_GET_BILLING_LINK(org as unknown as string);
  },
  method: 'get',
  paramsSelector:
    ({ payload }) =>
    () =>
      payload,
  successMock: IS_MOCK_ENABLED() ? MOCK_RESPONSE_GET_BILLING_LINK : undefined,
  selectors: {
    link: ({ selectors }) => createSelector(selectors.response, res => res?.link ?? ''),
  },
});
